import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { Contenuto } from '../../_class/contenuto';
import { WebserverService } from 'src/app/_service/webserver.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {
  contenuto: Contenuto;

  constructor(
    private route: ActivatedRoute,
    private webServerService: WebserverService,
    private sanitizer: DomSanitizer
  ) { }

  updateData(): void {
    this.webServerService.getContenuto(4)
    .subscribe(contenuto => this.contenuto = contenuto);
  }

  sanitizeString(string: string) {
    return this.sanitizer.bypassSecurityTrustHtml(string);
  }

  ngOnInit() {
    this.updateData();
  }
}
